import React from 'react';
import { Row, Col } from 'antd';
import './marketingHeader.css';

const MarketingHeader = (props) => (
  <Row>
    <Col span={2} />
    <Col>
      <div className='banner-wrapper'>
        <div className='banner-overlay'>
          <div className='banner-left'>
            <div className='logo-wrapper'>
              <img
                src='https://static.wixstatic.com/media/b2d40e_c244544b222f44f49e39fb89abaaf998~mv2.png'
                alt='Finneo Logo'
                className='banner-logo'
                />
            </div>
          </div>

          <div className='banner-center'>
            <h1 className='banner-title'>
              {props.heading}
            </h1>
            <p className='banner-subtitle'>
              Based on AI enhanced algorithm that takes into account recent
              loans done by over 3,000 lenders
            </p>
          </div>

          <div className='banner-right'>
            <div className='banner-stat-title'>TRANSACTIONS FACILITATED</div>

            <div className='banner-stat-block'>
              <div className='banner-stat-number'>$4B+</div>
              <div className='banner-stat-label'>Fundings</div>
            </div>
            <div className='banner-stat-block'>
              <div className='banner-stat-number'>367</div>
              <div className='banner-stat-label'>Deals</div>
            </div>
            <div className='banner-stat-block'>
              <div className='banner-stat-number'>3,576</div>
              <div className='banner-stat-label'>Lenders Tracked</div>
            </div>
            <div className='banner-stat-block'>
              <div className='banner-stat-number'>35</div>
              <div className='banner-stat-label'>Markets Serviced</div>
            </div>
          </div>
        </div>
      </div>
    </Col>
  </Row>
);

export default MarketingHeader;
